// utils/offlineStorage/class.ts - utils/offlineStorage/core.ts class split (core class)

import { CACHE_TTL } from './ttl.js';
import type {CacheItem} from './cacheItem.js';
import { applyQueriesMethods } from './queries.js';
import { applySyncMethods } from './sync.js';

export class OfflineStorage {
private readonly prefix = 'omd_cache_';

private readonly syncTimeKey = 'omd_last_sync_time';

/**
   * Save data to localStorage with TTL
   */
  set<T>(key: string, data: T, expiresIn: number = CACHE_TTL.DEFAULT): void {
    try {
      const cacheItem: CacheItem<T> = {
        data,
        timestamp: Date.now(),
        expiresIn,
      };
      localStorage.setItem(this.prefix + key, JSON.stringify(cacheItem));
    } catch (error) {
      console.error('Failed to save to offline storage:', error);
    }
  }

/**
   * Get data from localStorage, returns null if expired or not found
   */
  get<T>(key: string): T | null {
    try {
      const item = localStorage.getItem(this.prefix + key);
      if (!item) return null;

      const cacheItem: CacheItem<T> = JSON.parse(item);
      const isExpired = Date.now() - cacheItem.timestamp > cacheItem.expiresIn;

      if (isExpired) {
        this.remove(key);
        return null;
      }

      return cacheItem.data;
    } catch (error) {
      console.error('Failed to get from offline storage:', error);
      return null;
    }
  }
}

applyQueriesMethods();
applySyncMethods();
